import { Box, Divider, Flex, Text } from "@chakra-ui/react";

import { MessagesInner } from "@nens/rana/api-v1";

import { getPrettyDate } from "@/utils/get-pretty-time";

import { CommentMessage } from "./comment-components";

interface CommentProps {
  message: MessagesInner;
  lastMessage?: MessagesInner;
  nextMessage?: MessagesInner;
  showDate: boolean;
  onEdit: (body: string) => void;
  onRemove: () => void;
  onToggleReaction: (emoji: string) => void;
}

export function Comment(props: CommentProps) {
  const { message, showDate, lastMessage, nextMessage, onEdit, onRemove, onToggleReaction } = props;

  return (
    <Box>
      {showDate && (
        <Flex align="center">
          <Divider borderColor="brand.glacier" />
          <Text padding="4" fontSize="sm" color="brand.glacier" whiteSpace="nowrap">
            {getPrettyDate(message.createdAt)}
          </Text>
          <Divider borderColor="brand.glacier" />
        </Flex>
      )}
      <CommentMessage
        editMessage={onEdit}
        removeMessage={onRemove}
        {...{ lastMessage, nextMessage, message }}
        onToggleReaction={onToggleReaction}
      />
    </Box>
  );
}
